<template>
  <div class="page-shell">
    <div class="topbar">
      <div class="page-title"><h1>⭐ 推荐主播管理</h1><p>管理前台首页"主播推荐"模块的展示内容</p></div>
    </div>

    <div class="card">
      <div class="card-header"><h3>当前推荐主播列表（共{{ dataSource.featuredAnchors.length }}位）</h3><button class="btn btn-primary" :disabled="loading || anchorSubmitting" @click="openAnchorDialog()">+ 添加推荐主播</button></div>
      <div class="anchor-grid">
        <div v-for="(item,index) in dataSource.featuredAnchors" :key="item.id" class="anchor-card">
          <div class="featured-avatar-wrap">
            <img v-if="item.avatar" class="featured-avatar" :src="item.avatar" :alt="item.name" referrerpolicy="no-referrer">
            <div v-else class="featured-avatar featured-avatar--placeholder">{{ item.name.slice(0, 1) }}</div>
          </div>
          <div class="ac-name">{{ item.name }}</div>
          <div class="ac-type">{{ anchorTypeText(item.type) }}</div>
          <div class="ac-fans">粉丝 {{ item.fansCount || '—' }}</div>
          <div class="ac-sales">带货量 {{ item.salesVolume || '—' }}</div>
          <div class="ac-actions">
            <button class="btn btn-sm btn-outline" :disabled="anchorSubmitting" @click="openAnchorDialog(item)">编辑</button>
            <button class="btn btn-sm btn-danger" :disabled="anchorSubmitting" @click="removeAnchor(item.id)">移除</button>
            <button v-if="index>0" class="btn btn-sm" style="background:var(--cog-border-light)" :disabled="anchorSubmitting" @click="moveAnchor(item.id, 'up')">↑</button>
            <button v-if="index<dataSource.featuredAnchors.length-1" class="btn btn-sm" style="background:var(--cog-border-light)" :disabled="anchorSubmitting" @click="moveAnchor(item.id, 'down')">↓</button>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header"><h3>当前任务推荐列表（共{{ dataSource.featuredTasks.length }}个任务）</h3><button class="btn btn-primary" :disabled="loading || taskSubmitting" @click="openTaskDialog()">+ 添加推荐任务</button></div>
      <div class="table-wrap">
        <table>
          <thead><tr><th>任务名称</th><th>任务类型</th><th>报价</th><th>任务说明</th><th>操作</th></tr></thead>
          <tbody>
            <tr v-for="(item, index) in dataSource.featuredTasks" :key="item.id">
              <td><strong>{{ item.name }}</strong></td>
              <td><span :class="taskTagClass(item.type)">{{ taskTypeText(item.type) }}</span></td>
              <td style="color:var(--cog-primary);font-weight:600">{{ item.price }}</td>
              <td>{{ item.description || '—' }}</td>
              <td><button class="btn btn-sm btn-outline" :disabled="taskSubmitting" @click="openTaskDialog(item)">编辑</button>
              <button class="btn btn-sm btn-danger" :disabled="taskSubmitting" @click="removeTask(item.id)">删除</button>
              <button v-if="index>0" class="btn btn-sm" style="background:var(--cog-border-light)" :disabled="taskSubmitting" @click="moveTask(item.id, 'up')">↑</button>
              <button v-if="index<dataSource.featuredTasks.length-1" class="btn btn-sm" style="background:var(--cog-border-light)" :disabled="taskSubmitting" @click="moveTask(item.id, 'down')">↓</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <el-dialog :title="anchorForm.id ? '编辑推荐主播' : '添加推荐主播'" :visible.sync="anchorDialog">
      <div class="two-col-grid dialog-grid">
        <div class="form-group"><label>主播姓名 *</label><input v-model="anchorForm.name" type="text"></div>
        <div class="form-group"><label>主播类型 *</label><select v-model="anchorForm.type"><option value="" disabled>请选择主播类型</option><option v-for="option in anchorTypeOptions" :key="option.value" :value="option.value">{{ option.label }}</option></select></div>
        <div class="form-group"><label>粉丝数量 *</label><input v-model="anchorForm.fansCount" type="text"></div>
        <div class="form-group"><label>带货量 *</label><input v-model="anchorForm.salesVolume" type="text" placeholder="如：8.2亿"></div>
        <div class="form-group"><label>排序值</label><input v-model.number="anchorForm.sort" type="number" min="0"></div>
      </div>
      <div class="form-group"><label>主播头像 URL</label><input v-model="anchorForm.avatar" type="text" placeholder="请输入头像地址"></div>
      <div class="form-group"><label>主播头像</label><input type="file" accept="image/*" @change="handleAnchorImageUpload"></div>
      <div v-if="anchorUploadLoading" class="upload-hint">头像上传中...</div>
      <div v-if="anchorForm.avatar" class="avatar-preview"><img :src="anchorForm.avatar" :alt="anchorForm.name || '主播头像预览'" referrerpolicy="no-referrer"></div>
      <div slot="footer"><el-button @click="anchorDialog=false">取消</el-button><el-button type="primary" :loading="anchorSubmitting" :disabled="anchorUploadLoading" @click="saveAnchor">{{ anchorForm.id ? '确认保存' : '确认添加' }}</el-button></div>
    </el-dialog>

    <el-dialog :title="taskForm.id ? '编辑推荐任务' : '添加推荐任务'" :visible.sync="taskDialog">
      <div class="form-group"><label>任务名称 *</label><input v-model="taskForm.name" type="text"></div>
      <div class="two-col-grid dialog-grid">
        <div class="form-group"><label>任务类型 *</label><select v-model="taskForm.type"><option v-for="option in taskTypeOptions" :key="option.value" :value="option.value">{{ option.label }}</option></select></div>
        <div class="form-group"><label>报价 *</label><input v-model="taskForm.price" type="text" placeholder="如：¥8,000-15,000"></div>
        <div class="form-group"><label>排序值</label><input v-model.number="taskForm.sort" type="number" min="0"></div>
      </div>
      <div class="form-group"><label>任务说明 *</label><textarea v-model="taskForm.description" rows="4"></textarea></div>
      <div slot="footer"><el-button @click="taskDialog=false">取消</el-button><el-button type="primary" :loading="taskSubmitting" @click="saveTask">{{ taskForm.id ? '确认保存' : '确认添加' }}</el-button></div>
    </el-dialog>
  </div>
</template>

<script>
import {
  bannerUpload,
  streamerCreate,
  streamerDelete,
  streamerDetail,
  streamerList,
  streamerMove,
  streamerUpdate,
  taskCreate,
  taskDelete,
  taskDetail,
  taskList,
  taskMove,
  taskUpdate
} from '../../api/userMG'

const emptyAnchor = () => ({ id: null, name: '', type: '', fansCount: '', salesVolume: '', avatar: '', sort: 0 })
const emptyTask = () => ({ id: null, name: '', type: 'live', price: '', description: '', sort: 0 })
const ANCHOR_TYPE_OPTIONS = [
  { value: 'beauty_care', label: '美妆护肤' },
  { value: 'fashion_apparel', label: '服饰穿搭' },
  { value: 'food_beverage', label: '食品饮料' },
  { value: 'digital', label: '3C数码' },
  { value: 'home_living', label: '家居生活' },
  { value: 'maternity_child', label: '母婴育儿' },
  { value: 'education', label: '教育知识' },
  { value: 'sports_outdoors', label: '运动户外' },
  { value: 'gaming', label: '游戏电竞' }
]
const TASK_TYPE_OPTIONS = [
  { value: 'live', label: '直播' },
  { value: 'short_video', label: '短视频' },
  { value: 'vlog', label: 'Vlog' }
]

export default {
  name: 'home-featured',
  data() {
    return {
      dataSource: {
        featuredAnchors: [],
        featuredTasks: []
      },
      anchorDialog: false,
      taskDialog: false,
      anchorForm: emptyAnchor(),
      taskForm: emptyTask(),
      anchorTypeOptions: ANCHOR_TYPE_OPTIONS,
      taskTypeOptions: TASK_TYPE_OPTIONS,
      loading: false,
      anchorSubmitting: false,
      taskSubmitting: false,
      anchorUploadLoading: false
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    taskTagClass(type) {
      return {
        tag: true,
        'tag-blue': ['直播', 'live', 'live_stream'].includes(type),
        'tag-purple': ['短视频', 'short_video'].includes(type),
        'tag-green': ['vlog'].includes(type)
      }
    },
    anchorTypeText(type) {
      const target = this.anchorTypeOptions.find(item => item.value === type)
      return target ? target.label : type || '—'
    },
    taskTypeText(type) {
      const target = this.taskTypeOptions.find(item => item.value === type)
      return target ? target.label : type || '—'
    },
    async loadData() {
      this.loading = true

      try {
        await Promise.all([this.loadAnchors(), this.loadTasks()])
      } finally {
        this.loading = false
      }
    },
    async loadAnchors() {
      try {
        const res = await streamerList({ per_page: 100 })

        if (!this.isListSuccess(res)) {
          this.$message.error(this.getErrorMessage(res, '推荐主播列表加载失败'))
          return
        }

        this.dataSource.featuredAnchors = res.data.map(item => this.normalizeAnchor(item))
      } catch (error) {
        this.$message.error(this.getErrorMessage(error, '推荐主播列表加载失败'))
      }
    },
    async loadTasks() {
      try {
        const res = await taskList({ per_page: 100 })

        if (!this.isListSuccess(res)) {
          this.$message.error(this.getErrorMessage(res, '推荐任务列表加载失败'))
          return
        }

        this.dataSource.featuredTasks = res.data.map(item => this.normalizeTask(item))
      } catch (error) {
        this.$message.error(this.getErrorMessage(error, '推荐任务列表加载失败'))
      }
    },
    async openAnchorDialog(item) {
      if (!item || !item.id) {
        this.anchorForm = emptyAnchor()
        this.anchorDialog = true
        return
      }

      try {
        const res = await streamerDetail(item.id)
        const detail = this.extractDetail(res)

        if (!detail || !detail.id) {
          this.$message.error(this.getErrorMessage(res, '推荐主播详情加载失败'))
          return
        }

        this.anchorForm = this.normalizeAnchor(detail)
      } catch (error) {
        this.$message.error(this.getErrorMessage(error, '推荐主播详情加载失败'))
        return
      }

      this.anchorDialog = true
    },
    async handleAnchorImageUpload(event) {
      const file = event.target.files[0]
      if (!file) return

      const formData = new FormData()
      formData.append('file', file)
      this.anchorUploadLoading = true

      try {
        const res = await bannerUpload(formData)

        if (this.isRequestFailed(res)) {
          this.$message.error(this.getErrorMessage(res, '头像上传失败'))
          return
        }

        const imageUrl = this.extractUploadUrl(res)

        if (!imageUrl) {
          this.$message.error('上传成功，但未获取到头像地址')
          return
        }

        this.anchorForm.avatar = imageUrl
        this.$message.success('头像上传成功')
      } catch (error) {
        this.$message.error(this.getErrorMessage(error, '头像上传失败'))
      } finally {
        this.anchorUploadLoading = false
        event.target.value = ''
      }
    },
    async saveAnchor() {
      const payload = this.buildAnchorPayload()

      if (!payload.name || !payload.type || !payload.fans_count || !payload.sales_volume) {
        this.$message.warning('请填写完整的主播信息')
        return
      }

      this.anchorSubmitting = true

      try {
        const res = this.anchorForm.id
          ? await streamerUpdate(this.anchorForm.id, payload)
          : await streamerCreate(payload)

        if (this.isMutationFailed(res)) {
          this.$message.error(this.getErrorMessage(res, this.anchorForm.id ? '推荐主播更新失败' : '推荐主播创建失败'))
          return
        }

        this.anchorDialog = false
        this.$message.success(this.anchorForm.id ? '推荐主播已更新！' : '推荐主播已添加！')
        await this.loadAnchors()
      } catch (error) {
        this.$message.error(this.getErrorMessage(error, this.anchorForm.id ? '推荐主播更新失败' : '推荐主播创建失败'))
      } finally {
        this.anchorSubmitting = false
      }
    },
    async removeAnchor(id) {
      this.anchorSubmitting = true

      try {
        const res = await streamerDelete(id)

        if (this.isMutationFailed(res) && res !== 204) {
          this.$message.error(this.getErrorMessage(res, '推荐主播删除失败'))
          return
        }

        this.$message.success('推荐主播已移除！')
        await this.loadAnchors()
      } catch (error) {
        this.$message.error(this.getErrorMessage(error, '推荐主播删除失败'))
      } finally {
        this.anchorSubmitting = false
      }
    },
    async moveAnchor(id, direction) {
      this.anchorSubmitting = true

      try {
        const res = await streamerMove(id, { direction })

        if (this.isMutationFailed(res) && res !== 204) {
          this.$message.error(this.getErrorMessage(res, '推荐主播排序失败'))
          return
        }

        await this.loadAnchors()
      } catch (error) {
        this.$message.error(this.getErrorMessage(error, '推荐主播排序失败'))
      } finally {
        this.anchorSubmitting = false
      }
    },
    async openTaskDialog(item) {
      if (!item || !item.id) {
        this.taskForm = emptyTask()
        this.taskDialog = true
        return
      }

      try {
        const res = await taskDetail(item.id)
        const detail = this.extractDetail(res)

        if (!detail || !detail.id) {
          this.$message.error(this.getErrorMessage(res, '推荐任务详情加载失败'))
          return
        }

        this.taskForm = this.normalizeTask(detail)
      } catch (error) {
        this.$message.error(this.getErrorMessage(error, '推荐任务详情加载失败'))
        return
      }

      this.taskDialog = true
    },
    async saveTask() {
      const payload = this.buildTaskPayload()

      if (!payload.name || !payload.type || !payload.price || !payload.description) {
        this.$message.warning('请填写完整的任务信息')
        return
      }

      this.taskSubmitting = true

      try {
        const res = this.taskForm.id
          ? await taskUpdate(this.taskForm.id, payload)
          : await taskCreate(payload)

        if (this.isMutationFailed(res)) {
          this.$message.error(this.getErrorMessage(res, this.taskForm.id ? '推荐任务更新失败' : '推荐任务创建失败'))
          return
        }

        this.taskDialog = false
        this.$message.success(this.taskForm.id ? '推荐任务已更新！' : '推荐任务已添加！')
        await this.loadTasks()
      } catch (error) {
        this.$message.error(this.getErrorMessage(error, this.taskForm.id ? '推荐任务更新失败' : '推荐任务创建失败'))
      } finally {
        this.taskSubmitting = false
      }
    },
    async removeTask(id) {
      this.taskSubmitting = true

      try {
        const res = await taskDelete(id)

        if (this.isMutationFailed(res) && res !== 204) {
          this.$message.error(this.getErrorMessage(res, '推荐任务删除失败'))
          return
        }

        this.$message.success('推荐任务已删除！')
        await this.loadTasks()
      } catch (error) {
        this.$message.error(this.getErrorMessage(error, '推荐任务删除失败'))
      } finally {
        this.taskSubmitting = false
      }
    },
    async moveTask(id, direction) {
      this.taskSubmitting = true

      try {
        const res = await taskMove(id, { direction })

        if (this.isMutationFailed(res) && res !== 204) {
          this.$message.error(this.getErrorMessage(res, '推荐任务排序失败'))
          return
        }

        await this.loadTasks()
      } catch (error) {
        this.$message.error(this.getErrorMessage(error, '推荐任务排序失败'))
      } finally {
        this.taskSubmitting = false
      }
    },
    normalizeAnchor(item) {
      return {
        id: item.id,
        name: item.name || '',
        type: item.type || '',
        fansCount: item.fans_count || '',
        salesVolume: item.sales_volume || '',
        avatar: item.avatar || '',
        sort: item.sort === undefined || item.sort === null ? 0 : Number(item.sort)
      }
    },
    normalizeTask(item) {
      return {
        id: item.id,
        name: item.name || '',
        type: item.type || '',
        price: item.price || '',
        description: item.description || '',
        sort: item.sort === undefined || item.sort === null ? 0 : Number(item.sort)
      }
    },
    buildAnchorPayload() {
      return {
        name: (this.anchorForm.name || '').trim(),
        type: (this.anchorForm.type || '').trim(),
        fans_count: (this.anchorForm.fansCount || '').trim(),
        sales_volume: (this.anchorForm.salesVolume || '').trim(),
        avatar: (this.anchorForm.avatar || '').trim(),
        sort: this.anchorForm.sort === undefined || this.anchorForm.sort === null || this.anchorForm.sort === '' ? 0 : Number(this.anchorForm.sort)
      }
    },
    buildTaskPayload() {
      return {
        name: (this.taskForm.name || '').trim(),
        type: (this.taskForm.type || '').trim(),
        price: (this.taskForm.price || '').trim(),
        description: (this.taskForm.description || '').trim(),
        sort: this.taskForm.sort === undefined || this.taskForm.sort === null || this.taskForm.sort === '' ? 0 : Number(this.taskForm.sort)
      }
    },
    extractDetail(res) {
      if (!res || typeof res !== 'object' || res.message || res.detail || res.errors) {
        return null
      }

      if (res.data && !Array.isArray(res.data) && typeof res.data === 'object') {
        return res.data
      }

      return res
    },
    extractUploadUrl(res) {
      const payload = this.extractDetail(res)

      if (!payload || typeof payload !== 'object') {
        return ''
      }

      return payload.url || payload.image_url || payload.path || payload.file_url || ''
    },
    isListSuccess(res) {
      return !!(res && typeof res === 'object' && Array.isArray(res.data) && !res.message && !res.detail && !res.errors)
    },
    isRequestFailed(res) {
      return typeof res === 'string' || !!(res && typeof res === 'object' && (res.message || res.detail || res.errors))
    },
    isMutationFailed(res) {
      return typeof res === 'string' || !!(res && typeof res === 'object' && (res.detail || res.errors))
    },
    getErrorMessage(error, fallback) {
      if (!error) return fallback
      if (typeof error === 'string') return error
      if (error.message) return error.message
      if (error.detail) return error.detail
      if (error.errors) {
        const firstKey = Object.keys(error.errors)[0]
        const firstError = firstKey ? error.errors[firstKey] : ''

        if (Array.isArray(firstError)) {
          return firstError[0] || fallback
        }

        return firstError || fallback
      }

      return fallback
    }
  }
}
</script>

<style scoped>
.dialog-grid,
.form-group {
  margin-bottom: 14px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 600;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  min-height: 40px;
  padding: 10px 12px;
  border: 1.5px solid var(--cog-border);
  border-radius: var(--cog-radius-sm);
}

.form-group textarea {
  resize: vertical;
}

.upload-hint {
  margin-top: 8px;
  font-size: 12px;
  color: var(--cog-text-secondary);
}

.featured-avatar-wrap {
  margin: 0 auto 12px;
}

.featured-avatar {
  display: block;
  width: 72px;
  height: 72px;
  margin: 0 auto;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #eef2ff;
}

.featured-avatar--placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #6366f1, #06b6d4);
  color: #fff;
  font-size: 28px;
  font-weight: 700;
}

.ac-sales {
  margin-top: 4px;
  font-size: 13px;
  color: #7c3aed;
  font-weight: 600;
}

.ac-actions {
  margin-top: 10px;
}

.avatar-preview img {
  display: block;
  width: 96px;
  height: 96px;
  margin-top: 8px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid var(--cog-border);
}
</style>



// WEBPACK FOOTER //
// src/views/home/featured.vue